import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const tomos = [{
  emoji: '📘',
  title: 'FUNDAMENTOS DE ACERO',
  desc: 'Cómo funciona el algoritmo. El perfil que vende. Elección del producto estrella. Plan de 7 días para arrancar.'
}, {
  emoji: '📗',
  title: 'LANZALLAMAS DE ATENCIÓN',
  desc: '500 hooks listos para detener el scroll. Curiosidad, dolor, transformación, urgencia y visuales. Listos para copiar y grabar.'
}, {
  emoji: '📙',
  title: 'EL GUIÓN MAESTRO',
  desc: '100 scripts completos listos para grabar. Venta directa, educativos, testimonio, urgencia y objeción. Abrís y grabás.'
}, {
  emoji: '📕',
  title: 'ESTÉTICA QUE VENDE',
  desc: 'Edición en 20 minutos. Texto, subtítulos, transiciones y color. El feed que genera confianza antes de que te escriban.'
}, {
  emoji: '📓',
  title: 'EL CIERRE INEVITABLE',
  desc: 'Scripts de DM que cierran en 3 respuestas. Cómo convertir comentarios en ventas. Seguimiento de leads fríos.'
}, {
  emoji: '📔',
  title: 'DOMINIO MENSUAL',
  desc: 'Calendario de 30 días listo. Sistema de batching. Horarios de mayor conversión. Plan de 90 días para escalar.'
}];
const checklist = ['Abrís el PDF y arrancás hoy', 'Aplicable a cualquier nicho', 'Hooks, guiones y CTAs listos', 'Para cualquier nivel de experiencia', 'Diseñado para el emprendedor hispanohablante'];
export function TomosGrid() {
  return <section className="w-full py-14 px-4 bg-base relative" data-id="element-250">
      <div className="absolute inset-0 bg-primary/5 pointer-events-none" data-id="element-251" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-252">
        <div className="text-center mb-16" data-id="element-253">
          <h2 className="text-4xl md:text-5xl font-extrabold text-text-main mb-4" data-id="element-254">
            🏆 KIT PACK CREÁ REELS Y FACTURÁ DESDE 0
          </h2>
          <p className="text-xl text-primary font-semibold" data-id="element-255">
            6 Tomos + 6 Bonos · 300+ páginas · Todo resuelto
          </p>
        </div>

        <h3 className="text-2xl font-bold text-text-main mb-10 text-center flex items-center justify-center gap-3" data-id="element-256">
          💪 6 TOMOS COMPLETOS
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-257">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} whileHover={{
          y: -5
        }} className="bg-alt border border-alt hover:border-hover rounded-2xl p-8 transition-colors duration-300 group" data-id="element-258">
              <div className="text-5xl mb-6" data-id="element-259">{tomo.emoji}</div>
              <div className="text-primary text-sm font-bold tracking-wider mb-2" data-id="element-260">
                TOMO {i + 1}
              </div>
              <h4 className="text-xl font-bold text-text-main mb-4 group-hover:text-detail transition-colors" data-id="element-261">
                {tomo.title}
              </h4>
              <p className="text-text-muted leading-relaxed" data-id="element-262">{tomo.desc}</p>
            </motion.div>)}
        </div>

        <div className="max-w-3xl mx-auto bg-alt/50 rounded-3xl p-8 md:p-12 border border-primary/20" data-id="element-263">
          <ul className="space-y-4" data-id="element-264">
            {checklist.map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-265">
                <div className="bg-cta/20 p-1 rounded-full text-cta" data-id="element-266">
                  <Check size={20} strokeWidth={3} data-id="element-267" />
                </div>
                <span className="text-lg font-medium text-text-main" data-id="element-268">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}